import React from "react";
import { Link } from "react-router-dom";
import clausePage from "./ClausePage.module.css";
//icons
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import ListIcon from "@material-ui/icons/List";
// end icons

const Clause7 = () => {
  return (
    <>
      <div
        className="divflex"
        style={{ fontSize: "24px", textTransform: "uppercase" }}
      >
        Supplier Control
      </div>
      <main className={`${clausePage.container} ${clausePage.main}`}>
        <div>
          <Link to="/masterProcedureList?category=clause-7" className="panel">
            <ListIcon style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            Master <span className="card-btn-span">Procedure</span>
          </p>
        </div>
        <div>
          <Link to="/supplier/create" className="panel">
            <EmojiTransportationIcon
              style={{ fontSize: "3rem", color: "#003566" }}
            />
          </Link>
          <p className="card-btn-para">
            Master List of
            <span className="card-btn-span">Supplier</span>
          </p>
        </div>
        <div>
          <Link to="/supplierAuditPlanList" className="panel">
            <SupervisedUserCircleIcon
              style={{ fontSize: "3rem", color: "#003566" }}
            />
          </Link>
          <p className="card-btn-para">
            Supplier<span className="card-btn-span">Audit</span>
          </p>
        </div>
        <div>
          <Link to="/supplierRating" className="panel">
            <SupervisedUserCircleIcon
              style={{ fontSize: "3rem", color: "#003566" }}
            />
          </Link>
          <p className="card-btn-para">
            Supplier<span className="card-btn-span">Rating</span>
          </p>
        </div>
      </main>
    </>
  );
};

export default Clause7;
